import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
} from "@mui/material";
import "./PulseSelect.scss";

export interface PulseSelectOption {
  label: string;
  value: string;
}

interface PulseSelectProps {
  options: PulseSelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const PulseSelect: React.FC<PulseSelectProps> = ({
  options,
  value,
  onChange,
  placeholder,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth className="pulse-select">
      <Select
        value={value}
        onChange={handleChange}
        displayEmpty
        className="select-field"
        MenuProps={{
          className: "select-menu",
          PaperProps: {
            className: "select-paper",
          },
        }}
      >
        {placeholder && (
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PulseSelect;
